module.exports = __webpack_public_path__ + "media/assets/avia/sidebar/cents-b1737961f073d1d63ebdf7aa0a1cc691.png";